import React from "react";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { ReactComponent as AudienceBrandAffinityIcon } from "../../../../../images/profile-data/audience-brand-affinity.svg";
import { ReactComponent as TickYellow } from "../../../../../images/tick-yellow.svg";
import Tooltip from "../../../../components/Tooltip/Tooltip";
import { InterestsList } from "../components/InterestsList/InterestsList";
import ProfileBox, { PBHeader } from "../components/ProfileBox/ProfileBox";
import { ProgressBarList } from "../components/ProgressBarList/ProgressBarList";

export function AudienceBrandAffinity(props) {
  const { brandAffinity, height, onProjectDetails } = props;

  const onShowcase = height;

  return (
    <ProfileBox onProjectDetails={onProjectDetails} block={!onProjectDetails}>
      <PBHeader
        icon={<AudienceBrandAffinityIcon />}
        title={
          <IDHFormattedMessage
            id="ws_audience_brand_affinity"
            defaultMessage="Audience Brand Affinity"
          />
        }
        tooltip={
          !onShowcase && (
            <Tooltip
              center
              content={
                <IDHFormattedMessage
                  id="ws_tooltip_audience_brand_affinity"
                  defaultMessage={`Top 10 the most similar brands to the audience content. The percentage means what part of the audience is considered to be affiliated with a given brand. E.g. if "Apple" is the brand affinity, it is likely that the influencer’s followers have: Followed @Apple Liked @apple content frequently Written about @apple`}
                />
              }
            />
          )
        }
        onShowcase={onShowcase}
        onProjectDetails={onProjectDetails}
      />

      {onProjectDetails ? (
        <InterestsList
          data={brandAffinity}
          icon={<TickYellow />}
          fullWidthItem={onProjectDetails}
        />
      ) : (
        <ProgressBarList
          data={brandAffinity}
          icon={<TickYellow />}
          barColor="#FFB822"
          backgroundColor="rgba(255, 184, 34, 0.1)"
        />
      )}
    </ProfileBox>
  );
}
